module.exports = __webpack_public_path__ + "30c9818e4bc11c44728d610b15f630a2.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./client/assets/upicons.eot
 ** module id = 311
 ** module chunks = 0
 **/